import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
export function filterHiddenNavLinks(links, hidden) {
    if (hidden.size === 0) return links;
    return links.map((link)=>'items' in link ? _object_spread_props(_object_spread({}, link), {
            items: filterHiddenNavLinks(link.items, hidden)
        }) : link).filter((link)=>'url' in link ? !hidden.has(link.url) : link.items.length > 0);
}
